import { Stack, Typography, useTheme } from "@mui/material";
import { RootState } from "src/store";
import { connect } from "react-redux";
import { Button } from "@itk/mui-components";
import { genericTranslationsK, useGenericTranslationsT } from "src/translation-hooks/generic-translations";
import { addEditLabelActions } from "./add-edit-label-store";
import { useParams } from "react-router";
import { LabelsMultiSelectChip } from "../labels-multi-select-chip";
import { useRef, useState } from "react";
import { LabelsMultiSelectChipRef } from "../labels-multi-select-chip/labels-multi-select-chip-types";
import { configuratorActions } from "../../configurator-store";

const mapStateToProps = (state: RootState) => ({
  isShowingAddEditLabel: state.pageReducer.combinedConfiguratorReducer.addEditLabelReducer.isShowingAddEditLabel,
  selectedConfigurations: state.pageReducer.combinedConfiguratorReducer.configuratorReducer.selectedConfigurations
});

const ownActions = {
  setIsShowingAddEditLabel: addEditLabelActions.setIsShowingAddEditLabel,
  setSelectedConfigurations: configuratorActions.setSelectedConfigurations
};

type Props = typeof ownActions & ReturnType<typeof mapStateToProps>;

const AddEditLabelBase = (props: Props) => {
  const { isShowingAddEditLabel, setIsShowingAddEditLabel, selectedConfigurations, setSelectedConfigurations } = props;

  const theme = useTheme();
  const { projectId = "" } = useParams<{ projectId: string }>();
  const genericTranslationsT = useGenericTranslationsT();

  const labelsMultiChipRef = useRef<LabelsMultiSelectChipRef>(null);
  const [isLabelsLoading, setIsLabelsLoading] = useState(false);

  if (!isShowingAddEditLabel) return null;

  return (
    <Stack
      overflow="hidden"
      position="absolute"
      bottom={4}
      right={10}
      width={400}
      bgcolor={theme.palette.customColors.white}
      border={`1px solid ${theme.palette.customColors.grey}`}
      borderRadius={2}
      sx={{ boxShadow: "0px 4px 20px rgba(0,0,0,0.12)" }}
    >
      <Stack px={3} py={2}>
        <LabelsMultiSelectChip ref={labelsMultiChipRef} projectId={projectId} entityIds={selectedConfigurations} onLoadingChange={setIsLabelsLoading} />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="space-between" px={3} py={1.5} bgcolor={theme.palette.customColors.white} borderTop={`1px solid ${theme.palette.customColors.grey}`}>
        <Typography>{genericTranslationsT.selected(selectedConfigurations.length.toString())}</Typography>
        <Stack direction="row" alignContent="center" gap={2}>
          <Button
            disabled={isLabelsLoading}
            t={genericTranslationsT}
            k={genericTranslationsK}
            field="cancel"
            variant="outlined"
            onClick={() => {
              setIsShowingAddEditLabel(false);
            }}
          />
          <Button
            disabled={isLabelsLoading}
            loading={isLabelsLoading}
            t={genericTranslationsT}
            k={genericTranslationsK}
            field="apply"
            variant="contained"
            onClick={() => {
              labelsMultiChipRef.current?.handleApply(() => {
                setSelectedConfigurations([]);
                setIsShowingAddEditLabel(false);
              });
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};
export const AddEditLabel = connect(mapStateToProps, ownActions)(AddEditLabelBase);
